import classNames from "classnames";
import React from "react";

import { Search } from "@calcom/ui/components/icon";

import Button from "./Button";

export const NoSearchResultsFound = ({
  type,
  action,
  searchQuery,
  error,
  singular,
  plural,
  actionText = "Clear Search",
}: {
  type: "no-search" | "no-data";
  action?: () => void;
  actionText?: string;
  searchQuery: string;
  error?: string;
  singular: string;
  plural: string;
}) => {
  return (
    <div className="border-subtle flex w-full select-none flex-col items-center justify-center rounded-lg border border-dashed p-7 lg:p-20">
      <div className="mx-auto rounded-full bg-blue-100 p-3 text-blue-500 dark:bg-gray-800">
        <Search className="h-6 w-6 text-blue-500 dark:text-blue-400" />
      </div>
      <h1 className="mb-4 mt-3 text-xl text-gray-800 dark:text-white">No {plural} found</h1>
      {type === "no-search" ? (
        <>
          <p className="mt-2 ">{`Your requested params ${
            searchQuery ? searchQuery : ""
          } did not match any ${singular}.`}</p>
          <p className="mt-2">Please try again</p>
          {action && (
            <div className="mt-4 flex items-center gap-x-3 sm:mx-auto">
              <Button onClick={action}>{actionText}</Button>
            </div>
          )}
        </>
      ) : (
        <>
          <p className={classNames("mt-2", error && "text-red-500")}>
            {error ? error : `It looks like you don't have any ${plural} yet`}
          </p>
          {action && (
            <div className="mt-4 flex items-center gap-x-3 sm:mx-auto">
              <Button onClick={action}>Ok</Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NoSearchResultsFound;
